import './styles/cart.scss';
import './cart.js';
import './services/cartService.js';
import './directives/cartDirectives.js';
import './controllers/cartAddController.js';
import './controllers/cartConfirmController.js';
import './controllers/cartCountController.js';
import './controllers/cartFullController.js';
import './controllers/cartMiniController.js';
import './controllers/cartMiniListController.js';
import './controllers/cartMobileFullController.js';
import './controllers/cartPreorderController.js';
export default 'cart';